import { useCallback, useEffect } from 'react'

import { urlsConfig } from 'config/urls'

import { WindowEventMessage } from './types'

type ListenOptions<TPayload> = {
  onMessage: (payload: TPayload) => void
  eventSource: string
  eventName: string
  sameOrigin?: boolean
}

export function useListenMessage<TPayload>({
  onMessage,
  eventSource,
  eventName,
  sameOrigin = false,
}: ListenOptions<TPayload>) {
  const listenMessage = useCallback(
    async (event: MessageEvent<WindowEventMessage<TPayload>>) => {
      if (
        event.data?.source === eventSource &&
        event.data?.event === eventName &&
        (!sameOrigin || event.origin === window.origin || event.origin === urlsConfig.buy)
      ) {
        onMessage(event.data.payload)
      }
    },
    [eventName, eventSource, onMessage, sameOrigin],
  )

  useEffect(() => {
    window.addEventListener('message', listenMessage)
    return () => {
      window.removeEventListener('message', listenMessage)
    }
  }, [listenMessage])
}
